export const AUTH_FAILURE_SIGNIN = {
  message: 'Sign In Failed',
  description:
    'User failed to sign in. Confirm the username and password are correct.',
};
export const AUTH_FAILURE_REFRESH = {
  message: 'Session Ended',
  description: 'Your user session has ended. Please sign in again.',
};
export const AUTH_FAILURE_NOGROUP = {
  message: 'No Permission Group found',
  description:
    'This user is not assigned to a permission group. Please reach out to your Opticom representative to configure this for you.',
};
export const AUTH_FAILURE_NOAGENCY = {
  message: 'Agency Not Found',
  description:
    'This user is not assigned any Agency. Please reach out to your Opticom representative to configure this for you.',
};
